module.exports = __webpack_public_path__ + "media/grenade_video.d0584cb3.mp4";